import { createSlice } from "@reduxjs/toolkit";
import { fetchRedemptions } from "./thunkActions";

interface InitialState {
  isLoading: boolean;
  redemptions: IVoucherRedemptionList | null;
}

const initialState: InitialState = {
  isLoading: false,
  redemptions: null,
};

export const redemptionsSlice = createSlice({
  name: "redemptions",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRedemptions.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchRedemptions.fulfilled, (state, action) => {
        state.redemptions = action.payload;
        state.isLoading = false;
      })
      .addCase(fetchRedemptions.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default redemptionsSlice.reducer;
export * from "./thunkActions";
